angular.module('agreements')
    .component('agreementOffersTable', {
        bindings: {
            projectId: '<',
            query: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/agreements/offer/table-offer.html',
        controller($scope, $state, Project, ProjectService, Agreement, AgreementService, AgreementConst) {
            this.ProjectService = ProjectService;
            this.AgreementService = AgreementService

            this.$onChanges = () => {
                Agreement.tableOffer({mainProject: this.projectId, filter: 'granted', search: this.query}).$promise.then(data => {
                    this.page = data;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            }

            $scope.$on(AgreementConst.eventUpdate, () => this.$onChanges())
        }
    })
